/** The default number of rows that we show in the results table */
export const NUMBER_OF_ROWS = 10;
